import {
	Component,
	OnInit,
	Input,
	SimpleChanges,
	ViewEncapsulation,
	OnChanges
} from "@angular/core";

@Component({
	selector: "rbc-transition-number",
	templateUrl: "./transition-number.component.html",
	encapsulation: ViewEncapsulation.None,
	styleUrls: ["./transition-number.component.scss"]
})
export class TransitionNumberComponent implements OnInit, OnChanges {
	interval: number;
	displayNumber: number = 0;

	@Input() number: number = 0;

	constructor() {}

	ngOnInit() {
		this.number =
			this.number && typeof this.number === "number" ? this.number : 0;
		this.displayNumber = this.number ? this.number : 0;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.number) {
			this.scrollNumber();
		}
	}

	/**
	 * split difference into 10 parts, and increment by part every 15ms to cover difference
	 */
	scrollNumber() {
		clearInterval(this.interval);

		if (this.number == this.displayNumber) {
			return;
		}

		this.interval = window.setInterval(
			function() {
				if (this.displayNumber != this.number) {
					let change = (this.number - this.displayNumber) / 10;

					change =
						change >= 0 ? Math.ceil(change) : Math.floor(change);

					this.displayNumber = this.displayNumber + change;
				}
			}.bind(this),
			15
		);
	}
}
